'use strict';
var ClinicalUpdatesAuthorsController = /** @class */ (function () {
    function ClinicalUpdatesAuthorsController(ClinicalUpdatesAuthorService, $scope, $timeout, $sce) {
        'ngInject';
        var _this = this;
        this.downloadUrl = "";
        this.pageCount = function () {
            var itemsPerPage = 5;
            var items = [];
            return Math.ceil(10 / itemsPerPage) - 1;
        };
        this.range = function (startFrom, rangeSize) {
            var ret = [];
            for (var i = startFrom; i < startFrom + rangeSize; i++) {
                ret.push(i);
            }
            return ret;
        };
        this.pageNumberClick = function (index) {
            var _this = this;
            this.ClinicalUpdatesAuthorService.getClinicalUpdatesAuthorsData(index > 0 ? index : 1)
                .then(function (response) {
                if (response.currentPage.length > 0) {
                    _this.pageinationContentLength = response.currentPage.length;
                    if (_this.pageinationSize < _this.maxPageinationSize && index > _this.currentPageIndex && index - _this.pageinationSize == 1) {
                        _this.pageinationSize++;
                    }
                }
                _this.currentPageIndex = index > 0 ? index : 1;
                if (_this.currentPageIndex > _this.maxPageinationSize - 1) {
                    _this.pageinationStartFrom = _this.currentPageIndex - _this.maxPageinationSize;
                }
                _this.data_colomn = response.currentPage;
                _this.getFieldId(_this.data_colomn);
            });
        };
        this.downloadPDF = function (fileId) {
            var downloadUrl = "api/content/resourceContentFile/" + fileId + "/download";
            return downloadUrl;
        };
        this.getFieldId = function (data) {
            var numbers;
            var fileId = [];
            if (data.length) {
                for (var i = 0; i < data.length; i++) {
                    numbers = data[i].downloadUrl.split(/\//)[5];
                    fileId.push(numbers);
                }
                this.fileId = fileId;
            }
        };
        $scope.vm.isHeroTabs = false;
        var data;
        this.timeout = $timeout;
        this._$sce = $sce;
        this.currentPageIndex = 1;
        this.maxContentPerPage = 10;
        this.ClinicalUpdatesAuthorService = ClinicalUpdatesAuthorService;
        ClinicalUpdatesAuthorService.getClinicalUpdatesAuthorsData(this.currentPageIndex)
            .then(function (response) {
            var resp = response;
            _this.all_columns = ['Date', 'Topic(s)', 'Author(s)', 'Subject(s)'];
            _this.data_colomn = resp.currentPage;
            data = _this.data_colomn;
            if (response.currentPage.length > 0) {
                _this.pageinationContentLength = response.currentPage.length;
                _this.pageinationSize = 1;
                _this.maxPageinationSize = 10;
                _this.pageinationStartFrom = 0;
                _this.showPageination = true;
            }
            _this.getFieldId(data);
        });
    }
    return ClinicalUpdatesAuthorsController;
}());
export default ClinicalUpdatesAuthorsController;
//# sourceMappingURL=clinical-updates-authors.controller.js.map